export const PROFICIENCY = {
    NONE: 0,
    NORMAL: 1,
    EXPERT: 2
};